import * as firebase from 'firebase'
var firebaseConfig = {
  apiKey: 'AIzaSyBqVEHUuNeXCm4pfgHU7QJoybkp8qLQ1Ag',
  authDomain: 'project-a7194.firebaseapp.com',
  databaseURL: 'https://project-a7194.firebaseio.com',
  projectId: 'project-a7194',
  storageBucket: 'project-a7194.appspot.com',
  messagingSenderId: '866733963987',
  appId: '1:866733963987:web:91c5e6468fd1c3ed'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
var fireData = firebase.database()

export default {
  data () {
    return {
    }
  },

  methods: {
    getAll () {
      const vm = this
      fireData.ref('exam').once('value', (snapshot) => {
        let data = (snapshot.val())
        let userData = {}
        let user = (JSON.parse(window.localStorage.getItem('login')).username)
        for (let item in data) {
          if (data[item].user === user) {
            userData[item] = data[item]
          }
        }
        vm.examData = userData
      })
    },
    removeExam (id) {
      fireData.ref('exam').child(id).remove()
      this.getAll()
    },
    addExam (exam) {
      if (exam['practices']) {
        let contentRef = fireData.ref('exam').push()
        var key = contentRef.getKey()
        console.log(key)
        let user = (JSON.parse(window.localStorage.getItem('login')).username)
        contentRef.set({ exam })
        let userRef = fireData.ref('exam').child(contentRef.key)
        userRef.update({ user })
        return contentRef.getKey()
      } else {
        alert('請匯入正確的題組')
      }
    },
    getSingleExam (id) {
      const vm = this
      fireData.ref('exam').child(id).once('value', (snapshot) => {
        let data = (snapshot.val())
        vm.singleExam = data.exam
      })
    },
    modifyExam (id, exam) {
      if (exam.practices) {
        let checkExam = exam.practices.map((el) => {
          for (let key in el) {
            let itemCheck = el['items'].some(function (item, index, array) {
              return item === ''
            })
            console.log(itemCheck, key)
            if (!itemCheck && el['tile'] !== '' && el['answers'].length !== 0) {
              return el
            }
          }
        })
        let examList = [...checkExam]
        let checkIdx = examList.indexOf(undefined)
        if (checkIdx === -1) {
          var contentRef = fireData.ref('exam').child(id)
          contentRef.update({ exam })
          this.$router.push({ name: 'exam.editor' })
          this.$parent.getAll()
        } else {
          let indices = []
          while (checkIdx !== -1) {
            indices.push(checkIdx + 1)
            checkIdx = examList.indexOf(undefined, checkIdx + 1)
          }
          alert(`請將${indices}題，填寫完畢`)
        }
      } else {
        this.$router.push({ name: 'exam.editor' })
        this.$parent.getAll()
      }
    }
  }
}
